import { useContext, useEffect } from "react";
import { CardIcon } from "../../../../Layout/Common/CardIcon";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { formatAddress, payAccountClick } from "../../../../Layout/Common/common";
import { billAddressLine1Keys, billAddressToKeys, billContactLineKeys } from "../../../../constants";
import $ from "jquery";
export const OnAccountPayment = ({ handleOnCheck, defaultCheck }) => {
  const { billingAddress, selectedPaymentType } = useContext(GlobalContext);
  useEffect(() => {
    try {
      if (selectedPaymentType && selectedPaymentType === "OA") {
        $(".card-details-list1").hide("slow");
        $(".acc-details-list1").show("slow");
      } else {
        $(".acc-details-list1").hide("slow");
      }
    } catch (r) {
      console.error(r);
    }
  }, [selectedPaymentType]);
  return (
    <div className="change-accountShip shipPayment">
      <div className="shipping-method payment-card-list border-container" id="pay-account">
        <div className="shipping-method-info pay-option active" data-group={1} data-type="account">
          <div>
            <input
              className="form-check-input"
              type="radio"
              name="paymentMethod"
              id="paymentMethod1"
              value="OA"
              onChange={() => {
                handleOnCheck("OA");
              }}
              checked={defaultCheck || selectedPaymentType == "OA"}
            />
          </div>
          <label className="form-check-label" htmlFor="paymentMethod1">
            <div className="full-width d-flex align-items-center" style={{ gap: "10px" }} onClick={payAccountClick}>
              <div className="pay-icon">
                <CardIcon cardType="acc-pay" alt="account" />
              </div>
              <div>On Account</div>
            </div>
          </label>
        </div>
      </div>
      <div className="acc-details-list1 payment-option-container" style={{ display: "none" }}>
        <div className="row">
          <div className="col-md-2">
            <div className="bill-to">
              <h5>Bill To</h5>
            </div>
          </div>
          <div className="col-md-10">
            {billingAddress && (
              <div className="bill-address" style={{ textTransform: "capitalize" }}>
                <p>{formatAddress(billingAddress, billAddressToKeys)}</p>
                <address>
                  {formatAddress(billingAddress, billAddressLine1Keys).join(", ")}
                  <br />
                  Australia
                  <br />
                  {formatAddress(billingAddress, billContactLineKeys).join(", ")}
                </address>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
